import { useMutation, useQueryClient } from '@tanstack/react-query'
import { PermissoesApi } from '@/services/api-routes'
import type { Acao } from '@/utility/permissions'
import { permissoesKeys } from '@/http/queryKeys'
import { notifyErrorFor, notifySuccess } from '@/utility/notify'

export const useDefinirPermissoesMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      usuarioBackofficeId,
      acoes,
    }: {
      usuarioBackofficeId: string
      acoes: Acao[]
    }) => PermissoesApi.definir(usuarioBackofficeId, acoes),
    onSuccess: (_data, { usuarioBackofficeId }) => {
      void queryClient.invalidateQueries({
        queryKey: permissoesKeys.usuario(usuarioBackofficeId),
      })
      notifySuccess('Permissões atualizadas com sucesso!')
    },
    onError: (error) => notifyErrorFor('atualizar as permissões', error),
  })
}
